import React from 'react'
import useDashboardApi from '../../../../hooks/useDashboardApi'
import { LoadingButton, LoadingComponent } from 'usbc-web-react-library'
import OrderForm from '../../../shared/OrderForm/OrderForm';


function OrderDetailsView(props) {

    const {
        getOrderDetails,
        response: order,
        setResponse: setOrder,
        loading: getOrderDetailsLoading,
    } = useDashboardApi();

    React.useEffect(() => {
        if (!!props.order) {
            let body = {
                orderId: props.order.id
            };

            getOrderDetails(body).then((order) => {
            });
        }
    }, [props.order]);

    function onValidOrderSubmitted(order) {
        cancelHandler();
    }

    function cancelHandler() {
        setOrder({});
        props.onCancel();
    }

    return (
        <LoadingComponent isLoading={() => getOrderDetailsLoading} description="Loading Order Info" >
            {order != null &&
                <>
                    <OrderForm order={order} onValidOrderSubmitted={onValidOrderSubmitted} readOnly={true} />
                    <div className='row mt-3 pt-3 border-top'>
                        <div className="col-12">
                            <div className="d-flex justify-content-between">
                                <button className="btn btn-primary bowl-btn" type="button" onClick={cancelHandler}
                                    disabled={false}>
                                    <i className="bi bi-arrow-left-square"></i>
                                    <span className='ms-2'> Back</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            }
        </LoadingComponent>
    )
};

export default OrderDetailsView;

